import React from "react";

function Lightingn() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.93213 12.5405C1.74963 12.5411 1.5707 12.4899 1.41612 12.3929C1.26154 12.2959 1.13767 12.157 1.05889 11.9924C0.980114 11.8277 0.949664 11.6441 0.97108 11.4629C0.992497 11.2816 1.0649 11.1102 1.17988 10.9685L10.7277 1.13131C10.7993 1.04864 10.8969 0.992774 11.0045 0.972884C11.112 0.952994 11.2232 0.970261 11.3196 1.02185C11.4161 1.07344 11.4921 1.15628 11.5353 1.25679C11.5784 1.35729 11.5861 1.46948 11.5571 1.57494L9.70541 7.38079C9.65081 7.52693 9.63248 7.68413 9.65198 7.8389C9.67148 7.99368 9.72823 8.14142 9.81737 8.26944C9.90652 8.39747 10.0254 8.50196 10.1638 8.57395C10.3022 8.64594 10.456 8.68328 10.612 8.68277H17.363C17.5455 8.68215 17.7244 8.73332 17.879 8.83035C18.0336 8.92738 18.1574 9.06627 18.2362 9.2309C18.315 9.39552 18.3454 9.57912 18.324 9.76037C18.3026 9.94161 18.2302 10.1131 18.1152 10.2548L8.56739 20.0919C8.49577 20.1746 8.39817 20.2305 8.29062 20.2504C8.18306 20.2703 8.07194 20.253 7.97549 20.2014C7.87904 20.1498 7.803 20.067 7.75984 19.9665C7.71668 19.866 7.70898 19.7538 7.73798 19.6483L9.58968 13.8425C9.64428 13.6963 9.66262 13.5391 9.64312 13.3843C9.62362 13.2296 9.56686 13.0818 9.47772 12.9538C9.38858 12.8258 9.26971 12.7213 9.13131 12.6493C8.99292 12.5773 8.83912 12.54 8.68312 12.5405H1.93213Z"
        stroke="#424242"
        strokeWidth="1.92885"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Lightingn;
